/* AstroIndie storefront behaviour: mobile menu, and loading the chart engine
   that sits directly in the page. */
(function () {
  'use strict';

  /* ---------- mobile menu ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.getElementById('drawer');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- shared script loader (each file downloads once) ---------- */
  var SCRIPTS = {};
  function loadScript(src) {
    if (!SCRIPTS[src]) {
      SCRIPTS[src] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src; s.onload = resolve; s.onerror = reject;
        document.body.appendChild(s);
      });
    }
    return SCRIPTS[src];
  }

  /* ---------- chart engine ---------- */
  var FREE = ['kundali', 'match', 'rectify', 'muhurta', 'prashna'];
  var root = document.querySelector('.jk-root[data-jk-lazy]');
  var q; try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
  var chipNav = document.querySelector('[data-default-tool]');
  var engineReady = false, waiting = [];

  function whenReady(fn) { if (engineReady) fn(); else waiting.push(fn); }

  function scrollToEngine() {
    if (!root) return;
    var header = document.querySelector('.site-header');
    var off = header ? header.getBoundingClientRect().height : 0;
    var y = root.getBoundingClientRect().top + window.pageYOffset - off - 12;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  if (root) {
    /* Free tools page: no ?mode= means "show the tool chosen in the editor". */
    if (chipNav && q && !q.get('mode')) {
      var def = chipNav.getAttribute('data-default-tool');
      if (def && def !== 'kundali' && FREE.indexOf(def) > -1) {
        whenReady(function () { if (window.__setMode) window.__setMode(def); });
      }
    }

    var started = false;
    var frame = root.closest('.frame');
    var status = frame ? frame.querySelector('.frame__status') : null;
    var load = function () {
      if (started) return;
      started = true;
      loadScript(root.dataset.srcEphem)
        .then(function () { return loadScript(root.dataset.srcCities); })
        .then(function () { return loadScript(root.dataset.srcEngine); })
        .then(function () {
          engineReady = true;
          if (frame) frame.classList.add('is-ready');
          /* Anything typed into a place field while the data was still loading:
             show its suggestions now instead of waiting for the next key. */
          ['fplace', 'bplace'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el && el.value && document.activeElement === el) el.dispatchEvent(new Event('input'));
          });
          waiting.splice(0).forEach(function (fn) { try { fn(); } catch (e) { console.error(e); } });
        })
        .catch(function () { if (status) status.textContent = 'The calculator could not load. Please refresh the page.'; });
    };
    root.addEventListener('focusin', load);
    root.addEventListener('pointerdown', load);
    if (q && (q.get('mode') || q.get('auto') || q.get('date'))) load();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '900px 0px' });
      io.observe(root);
    } else {
      load();
    }
    /* Arriving with a prefilled, auto-cast link (from My reports): bring the report into view. */
    if (q && q.get('auto') === '1') whenReady(function () { setTimeout(scrollToEngine, 400); });
  }


  /* ---------- free chart: ask for email + mobile, then email the PDF ---------- */
  function toast(msg, bad) {
    var t = document.createElement('div');
    t.className = 'ga-toast' + (bad ? ' is-bad' : '');
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); }, 6500);
  }
  if (root && root.dataset.askMail === '1' && root.dataset.mailer) {
    whenReady(function () {
      var $id = function (i) { return document.getElementById(i); };
      var box = $id('jkMail'), em = $id('jkEmail'), ph = $id('jkPhone'), hp = $id('jkHp');
      var gate = $id('gate'), err = $id('ferr'), modewrap = $id('modewrap');
      if (!box || !em || !ph || !gate) return;
      var url = root.dataset.mailer.replace(/\/$/, '') + '/api/free-chart';
      var pending = null;
      var curMode = function () {
        var b = document.querySelector('#modewrap button[aria-pressed="true"]');
        return b ? b.getAttribute('data-m') : 'kundali';
      };
      var sync = function () { box.hidden = curMode() !== 'kundali'; };
      sync();
      if (modewrap) new MutationObserver(sync).observe(modewrap, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
      try { em.value = em.value || localStorage.getItem('ai_email') || ''; ph.value = ph.value || localStorage.getItem('ai_phone') || ''; } catch (e) {}

      /* Runs before the engine's own Cast handler, so it can stop an incomplete form. */
      document.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('#cast')) return;
        pending = null;
        if (box.hidden || !e.isTrusted) return;          // other tools, or automatic re-casts
        var email = em.value.trim(), phone = ph.value.trim();
        var badE = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
        var digits = phone.replace(/\D/g, '');
        var badP = digits.length < 8 || digits.length > 15;
        em.classList.toggle('is-bad', badE); ph.classList.toggle('is-bad', badP);
        if (badE || badP) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          if (err) err.textContent = 'Please enter your email and mobile number, so we can send you the PDF of your chart.';
          (badE ? em : ph).focus();
          return;
        }
        try { localStorage.setItem('ai_email', email); localStorage.setItem('ai_phone', phone); } catch (x) {}
        pending = { email: email, phone: phone, hp: hp ? hp.value : '' };
      }, true);

      /* When the chart appears, ask the mailer to send its PDF. */
      new MutationObserver(function () {
        if (!gate.hidden || !pending) return;
        var p = pending; pending = null;
        var v = function (i) { var el = $id(i); return el ? el.value : ''; };
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: v('fname'), date: v('fdate'), time: v('ftime'), place: v('fplace'),
            lat: v('flat'), lon: v('flon'), tz: v('ftz'),
            email: p.email, phone: p.phone, hp: p.hp
          })
        }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (x) {
            if (x.ok) toast('Your chart is on its way to ' + p.email + ' as a PDF. It usually arrives within a few minutes.');
            else toast((x.j && x.j.error) || 'We could not email your chart just now. Please try again.', true);
          })
          .catch(function () { toast('We could not email your chart just now. Your chart is shown below.', true); });
      }).observe(gate, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  /* ---------- free tools page: switch tool without reloading ---------- */
  function markChip(mode) {
    document.querySelectorAll('[data-tool-chip]').forEach(function (c) {
      c.setAttribute('aria-current', String(c.getAttribute('data-tool-chip') === mode));
    });
  }
  document.querySelectorAll('[data-tool-chip]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      if (!engineReady || !window.__setMode) return;   // not loaded yet: follow the link
      e.preventDefault();
      var mode = chip.getAttribute('data-tool-chip');
      var gate = document.getElementById('gate');
      var reset = document.getElementById('reset');
      if (gate && gate.hidden && reset) reset.click();
      window.__setMode(mode);
      markChip(mode);
      try { history.replaceState(null, '', '?mode=' + mode); } catch (err) {}
      scrollToEngine();
    });
  });
  if (q && q.get('mode') && FREE.indexOf(q.get('mode')) > -1) markChip(q.get('mode'));


  /* ---------- birth-place search in the report buy form ---------- */
  function citySearch(q) {
    var C = window.__JK_CITIES;
    if (!C) return [];
    if (!C._idx) C._idx = C.c.map(function (r) { return r[0].toLowerCase(); });
    q = q.split(',')[0].trim().toLowerCase();
    if (q.length < 2) return [];
    var starts = [], has = [];
    for (var i = 0; i < C._idx.length; i++) {
      var k = C._idx[i];
      if (k.indexOf(q) === 0) { starts.push(i); if (starts.length >= 40) break; }
      else if (has.length < 20 && k.indexOf(q) > -1) has.push(i);
    }
    return starts.concat(has).slice(0, 30).map(function (i) {
      var r = C.c[i];
      return { name: r[0], country: C.ccn[r[1]], lat: r[2], lon: r[3], tz: C.tz[r[4]], pop: r[5] };
    });
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  document.querySelectorAll('[data-city-ac]').forEach(function (input) {
    var box = input.closest('.city-field');
    var listEl = box.querySelector('.city-list');
    var lat = box.querySelector('[data-city-lat]'), lon = box.querySelector('[data-city-lon]'), tz = box.querySelector('[data-city-tz]');
    var note = box.querySelector('[data-city-note]');
    var src = input.getAttribute('data-cities-src');
    var items = [], active = -1, chosen = '';

    function setNote(text, cls) { note.textContent = text; note.className = 'city-note' + (cls ? ' ' + cls : ''); }
    function close() { listEl.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function clearChoice() { lat.value = lon.value = tz.value = ''; chosen = ''; }
    function choose(c) {
      input.value = c.name + ', ' + c.country;
      lat.value = c.lat; lon.value = c.lon; tz.value = c.tz;
      chosen = input.value;
      input.setCustomValidity('');
      setNote('Time zone ' + c.tz, 'is-ok');
      close();
    }
    function render() {
      items = citySearch(input.value);
      if (!items.length) {
        close();
        if (input.value.trim().length >= 2 && window.__JK_CITIES) setNote('No match. Check the spelling, or type the nearest larger town.', 'is-err');
        return;
      }
      setNote('');
      listEl.innerHTML = items.map(function (c, i) {
        var pop = c.pop >= 1000 ? Math.round(c.pop / 1000) + 'M' : c.pop + 'k';
        return '<div class="city-opt" role="option" id="p-place-o' + i + '" data-i="' + i + '"><b>' + esc(c.name) + '</b><span>' + esc(c.country) + '</span><em>' + pop + '</em></div>';
      }).join('');
      listEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    function ensureData() {
      if (window.__JK_CITIES) return Promise.resolve();
      setNote('Loading places\u2026');
      return loadScript(src).then(function () { setNote(''); });
    }

    input.addEventListener('focus', function () { ensureData(); });
    input.addEventListener('input', function () {
      if (input.value !== chosen) clearChoice();
      input.setCustomValidity('');
      ensureData().then(function () { if (document.activeElement === input) render(); });
    });
    input.addEventListener('keydown', function (e) {
      if (listEl.hidden) return;
      var opts = listEl.querySelectorAll('.city-opt');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = Math.max(0, Math.min(opts.length - 1, active + (e.key === 'ArrowDown' ? 1 : -1)));
        opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); });
        opts[active].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', opts[active].id);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        choose(items[active >= 0 ? active : 0]);
      } else if (e.key === 'Escape') { close(); }
    });
    /* mousedown so the choice lands before the input loses focus */
    listEl.addEventListener('mousedown', function (e) {
      var o = e.target.closest('.city-opt');
      if (!o) return;
      e.preventDefault();
      choose(items[+o.getAttribute('data-i')]);
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });

    /* Ask for a place from the list, so the report is cast for the right town and time zone. */
    var form = input.form;
    if (form) form.addEventListener('submit', function (e) {
      if (lat.value) return;
      var found = citySearch(input.value);
      if (found.length) {
        var exact = found.filter(function (c) { return c.name.toLowerCase() === input.value.split(',')[0].trim().toLowerCase(); });
        if (exact.length === 1) { choose(exact[0]); return; }
        e.preventDefault();
        input.setCustomValidity('Please choose your birth place from the list.');
        input.reportValidity();
        input.focus();
        render();
      }
    });
  });

  /* ---------- report buy form: keep the time field honest ---------- */
  document.querySelectorAll('[data-unknown-time]').forEach(function (cb) {
    var input = document.getElementById(cb.getAttribute('data-unknown-time'));
    if (!input) return;
    cb.addEventListener('change', function () {
      input.disabled = cb.checked;
      input.required = !cb.checked;
      if (cb.checked) input.value = '';
    });
  });
})();
